export const DEBUG = false;
export const LOG_PREFIX = '[VueContextify]';
export const DIRECTIVE_NAME = 'context-menu';
export const COMPONENT_NAME = 'VContextProvider';